import React from "react";
import { CheckCircle2Icon } from "lucide-react";
import { OfferBox } from "../OfferBox";
import { finalIncludes } from "../../data/offer";
import { MOCKUP_IMAGE } from "../../data/links";
const imagineLines = ["A clear sequence for reviewing available patient history.", "A structured approach to documenting hair loss patterns.", "Visual references for studying trichoscopic findings.", "Educational flowcharts for organizing differential diagnosis considerations.", "And practical worksheets for documenting the information that may require further evaluation."];
export function FinalCTA() {
  return <section className="bg-navy-950 px-4 py-16 text-white sm:px-6 sm:py-20" data-id="element-207" data-mp="33w7llye3t2x3">
      <div className="mx-auto max-w-3xl text-center" data-id="element-208" data-mp="38t7gre9f0l9f">
        <p className="text-sm font-bold uppercase tracking-[0.14em] text-gold" data-id="element-209" data-mp="38w3gn84tpk0i">
          Ready to give your next hair loss assessment a clearer structure?
        </p>
        <h2 className="mt-3 font-display text-4xl font-extrabold uppercase leading-[1.02] sm:text-6xl" data-id="element-210" data-mp="171b8qemghtje">
          Structure your next hair loss assessment in{" "}
          <span className="text-brand-light" data-id="element-211" data-mp="la280px1esbl">just 15 minutes</span> — with a step-by-step clinical
          roadmap.
        </h2>
        <p className="mt-6 text-lg leading-relaxed text-white/85" data-id="element-212" data-mp="yznitd0oo18j">
          Imagine opening one organized framework instead of searching through multiple disconnected
          references.
        </p>
      </div>

      <ul className="mx-auto mt-6 max-w-2xl space-y-2.5" data-id="element-213" data-mp="7aawcvtzto0r">
        {imagineLines.map(l => <li key={l} className="flex items-start gap-3 text-[17px] leading-snug text-white/90" data-id="element-214" data-mp="2c93jj6rmac3">
            <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-brand-light" aria-hidden="true" data-id="element-215" data-mp="gc0q48bckz1p" />
            {l}
          </li>)}
      </ul>
      <p className="mt-6 text-center text-lg font-semibold" data-id="element-216" data-mp="1rpcm5x0v8ddb">
        That’s the purpose of ALOPECIA CLINICAL BLUEPRINT™.
      </p>

      <div className="mx-auto mt-10 max-w-5xl" data-id="element-217" data-mp="1mpq7rk9awr2x">
        <img src={MOCKUP_IMAGE} alt="The complete Alopecia Clinical Blueprint collection" className="mx-auto w-full max-w-3xl rounded-3xl bg-white p-2 sm:p-4" loading="lazy" data-id="element-218" data-mp="kd3rwb6oooic" />
      </div>

      <div className="mx-auto mt-10 grid max-w-5xl items-start gap-8 lg:grid-cols-[1fr_1.1fr]" data-id="element-219" data-mp="peawk1dj57ks">
        <div className="rounded-3xl bg-navy-800 p-5 sm:p-7" data-id="element-220" data-mp="tbp4lpph59b7">
          <h3 className="font-display text-2xl font-extrabold uppercase" data-id="element-221" data-mp="yblbbwpk3eug">Your complete collection includes</h3>
          <ul className="mt-4 space-y-2.5" data-id="element-222" data-mp="1o6w22vn1ny0">
            {finalIncludes.map(item => <li key={item} className="flex items-start gap-2.5 text-[17px] font-medium leading-snug" data-id="element-223" data-mp="5p0kcxczt4rf">
                <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-success" aria-hidden="true" data-id="element-224" data-mp="amimo4wi8lqg" />
                {item}
              </li>)}
          </ul>
        </div>
        <OfferBox ctaLabel="Yes! I want the Alopecia Clinical Blueprint™ now" ctaNote="Digital product · One-time payment · No recurring subscription" data-id="element-225" data-mp="3e2zhi2bpaw6i" />
      </div>
      <p className="mx-auto mt-6 max-w-xl text-center text-sm text-white/60" data-id="element-226" data-mp="3bjul3p4w9a2x">
        Final payment options, currency conversion, and access details will be displayed at checkout.
      </p>
    </section>;
}